import { Dispatch } from "react";
import { Action } from "redux";
import { ReportViewSlice } from "./reducer";
import { ColdexAPI } from "../../../apis/apiColdex/ColdexAPI";
import { EmbedConfig } from "../../../utils/types/EmbedConfig";
import { URL_REPORT_POWER_BI } from "../../../utils/constants/api-constants";

export const ReportViewEffect = {
  clean: () => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ReportViewSlice.actions.clean());
    };
  },
  getEmbedConfig: (reportId: string) => {
    return async (dispatch: Dispatch<Action>) => {
      dispatch(ReportViewSlice.actions.getEmbedConfig());

      ColdexAPI.get<EmbedConfig>(`${URL_REPORT_POWER_BI}${reportId}`)
        .then(({ data }) => {
          dispatch(ReportViewSlice.actions.getEmbedConfigSuccess(data));
        })
        .catch((error) => {
          dispatch(
            ReportViewSlice.actions.getEmbedConfigError({
              iserror: true,
              shorterror: `Error short`,
              error,
            })
          );
        });
    };
  },
};
